'use strict';

var desktopQuery = window.matchMedia('(min-width: 768px)');

function pickSource(video) {
    return desktopQuery.matches ? video.dataset.srcDesktop : video.dataset.srcMobile;
}

function fallbackToPoster(video) {
    video.pause();
    video.removeAttribute('src');
    video.classList.remove('is-playing');
}

function play(video) {
    var promise = video.play();
    if (promise && promise.catch) {
        promise.catch(function () {
            fallbackToPoster(video);
        });
    }
}

function loadSource(video) {
    var src = pickSource(video);
    if (!src) {
        fallbackToPoster(video);
        return;
    }
    if (video.getAttribute('src') !== src) {
        video.src = src;
    }
    if (video.dataset.inView === 'true') {
        play(video);
    }
}

function init(video) {
    video.muted = true;

    video.addEventListener('playing', function () {
        video.classList.add('is-playing');
    });
    video.addEventListener('error', function () {
        fallbackToPoster(video);
    });

    if (!('IntersectionObserver' in window)) {
        video.dataset.inView = 'true';
        loadSource(video);
        return;
    }

    new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            video.dataset.inView = entry.isIntersecting ? 'true' : 'false';
            if (entry.isIntersecting) {
                loadSource(video);
            } else if (!video.paused) {
                video.pause();
            }
        });
    }, { rootMargin: '200px 0px' }).observe(video);

    var onBreakpointChange = function () {
        if (video.dataset.inView === 'true') {
            loadSource(video);
        }
    };
    if (desktopQuery.addEventListener) {
        desktopQuery.addEventListener('change', onBreakpointChange);
    } else {
        desktopQuery.addListener(onBreakpointChange);
    }
}

function initAll() {
    document.querySelectorAll('.wgaca-video-hero__video:not([data-initialized])').forEach(function (video) {
        video.setAttribute('data-initialized', 'true');
        init(video);
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
} else {
    initAll();
}
